/* eslint-disable no-process-env */
/* eslint-disable import/first */

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}

import React from 'preact/compat';

import {ProductPage} from 'features/ProductPage';
import {LocationContextProvider} from 'utilities/location';
import {ShadowRootContext} from 'utilities/dom';
import {AppState, useAppState} from 'utilities/app-state';

interface Props {
  variantId?: number;
  sellingPlanId?: number;
  shadowRoot?: ShadowRoot;
}

export function App({variantId, sellingPlanId, shadowRoot}: Props) {
  const appState = useAppState();
  return (
    <React.StrictMode>
      <ShadowRootContext.Provider value={shadowRoot}>
        <LocationContextProvider>
          <AppState.Provider value={appState}>
            <ProductPage variantId={variantId} sellingPlanId={sellingPlanId} />
          </AppState.Provider>
        </LocationContextProvider>
      </ShadowRootContext.Provider>
    </React.StrictMode>
  );
}
